module.exports = __webpack_public_path__ + "img/rocket-small-blue.4b7f35f7.svg";